var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewNotificationicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51621 2.30377C6.89579 2.30377 4.76621 4.43336 4.76621 7.05377V9.34169C4.76621 9.82461 4.56038 10.5609 4.31496 10.9725L3.40454 12.4846C2.84246 13.4188 3.23037 14.4559 4.25954 14.8042C7.67163 15.9442 11.3529 15.9442 14.765 14.8042C15.7229 14.4875 16.1425 13.3554 15.62 12.4846L14.7095 10.9725C14.472 10.5609 14.2662 9.82461 14.2662 9.34169V7.05377C14.2662 4.44127 12.1287 2.30377 9.51621 2.30377Z",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9799 2.53333C10.7345 2.46208 10.4812 2.40666 10.2199 2.37499C9.45995 2.27999 8.73161 2.33541 8.05078 2.53333C8.28036 1.94749 8.85037 1.53583 9.51537 1.53583C10.1804 1.53583 10.7504 1.94749 10.9799 2.53333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8906 15.0892C11.8906 16.3954 10.8219 17.4642 9.51563 17.4642C8.86646 17.4642 8.26479 17.195 7.83729 16.7675C7.40979 16.34 7.14062 15.7383 7.14062 15.0892",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8906 15.0892C11.8906 16.3954 10.8219 17.4642 9.51563 17.4642C8.86646 17.4642 8.26479 17.195 7.83729 16.7675C7.40979 16.34 7.14062 15.7383 7.14062 15.0892",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotificationicon);
export default __webpack_public_path__ + "static/media/newNotification.icon.5c7c50711ebf4256fce1e28484063103.svg";
export { ForwardRef as ReactComponent };